import React from "react";
import { SectionCTA } from "./SectionCTA";
import { patientVignettes } from "../data/content";
export function ProblemIntro() {
  return <section className="bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-281" data-mp="3qvphgpfrm2c1">
      <div className="mx-auto max-w-5xl" data-id="element-282" data-mp="3bxx5g79ffw2l">
        <div className="grid gap-10 md:grid-cols-[1fr_1.1fr] md:gap-16" data-id="element-283" data-mp="3bz86hzbhmpq0">
          <div data-id="element-284" data-mp="3gwzz6vjyifv9">
            <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-285" data-mp="3gwgrs8rxn9vh">
              From unclear symptoms to a structured clinical decision pathway
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-286" data-mp="dhkp5ubkw6a4">
              Perimenopause rarely presents as one simple, predictable clinical picture.
            </p>
          </div>
          <ol className="relative space-y-6 border-l-2 border-brand-200 pl-6" data-id="element-287" data-mp="3nvjn1r21rwu">
            {patientVignettes.map((v, i) => <li key={v} className="relative" data-id="element-288" data-mp="w5zfsghzhiae" data-mpi={i}>
                <span className="absolute -left-[35px] top-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-brand-700 text-xs font-bold text-white" data-id="element-289" data-mp="w6rdbwv55q3b">
                  {i + 1}
                </span>
                <p className="text-lg font-semibold leading-snug text-ink" data-id="element-290" data-mp="c0gezfk98cpk">{v}</p>
              </li>)}
          </ol>
        </div>

        <div className="mt-14 rounded-3xl bg-brand-50 p-7 md:p-10" data-id="element-291" data-mp="lx31e8s8bbtp">
          <p className="text-lg text-muted" data-id="element-292" data-mp="lvrx87uvg222">The challenge isn't simply recognizing possible perimenopause.</p>
          <p className="mt-2 text-2xl font-extrabold leading-snug text-brand-900 md:text-3xl" data-id="element-293" data-mp="zqki7ltj6ag1">
            It's organizing the clinical information into a defensible assessment and management workflow.
          </p>
          <p className="mt-4 text-lg font-semibold text-brand-700" data-id="element-294" data-mp="14nkp1yy7fh87">That's exactly what this roadmap is designed to support.</p>
        </div>

        <SectionCTA label="Give me a clear pathway for every case" data-id="element-295" data-mp="3bf1wtb85qlc0" />
      </div>
    </section>;
}